import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './stores/auth-context';
import { ModeProvider } from './stores/mode-context';
import { AuthGuard } from './components/auth/AuthGuard';
import { RoleGuard } from './components/auth/RoleGuard';
import { RootRedirect } from './components/auth/RootRedirect';
import { AppShell } from './components/layout/AppShell';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ImportPage } from './pages/ImportPage';
import { QrRegistrationPage } from './pages/QrRegistrationPage';
import { SettingsPage } from './pages/SettingsPage';
import { MobileSuccessPage } from './pages/MobileSuccessPage';
import { ScanPage } from './pages/ScanPage';
import { UserManagementPage } from './pages/UserManagementPage';
import { MonitoringDashboardPage } from './pages/MonitoringDashboardPage';

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <ModeProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/dashboard"
                element={
                  <AuthGuard>
                    <RoleGuard roles={['admin', 'accountant']}>
                      <AppShell>
                        <DashboardPage />
                      </AppShell>
                    </RoleGuard>
                  </AuthGuard>
                }
              />
              <Route
                path="/input-data"
                element={
                  <AuthGuard>
                    <RoleGuard roles={['admin']}>
                      <AppShell>
                        <ImportPage />
                      </AppShell>
                    </RoleGuard>
                  </AuthGuard>
                }
              />
              <Route
                path="/settings"
                element={
                  <AuthGuard>
                    <RoleGuard roles={['admin', 'accountant']}>
                      <AppShell>
                        <SettingsPage />
                      </AppShell>
                    </RoleGuard>
                  </AuthGuard>
                }
              />
              <Route
                path="/scan"
                element={
                  <AuthGuard>
                    <RoleGuard roles={['admin', 'operator']}>
                      <ScanPage />
                    </RoleGuard>
                  </AuthGuard>
                }
              />
              <Route
                path="/users"
                element={
                  <AuthGuard>
                    <RoleGuard roles={['admin']}>
                      <AppShell>
                        <UserManagementPage />
                      </AppShell>
                    </RoleGuard>
                  </AuthGuard>
                }
              />
              <Route
                path="/monitoring"
                element={
                  <AuthGuard>
                    <MonitoringDashboardPage />
                  </AuthGuard>
                }
              />
              <Route path="/mobile-success" element={<MobileSuccessPage />} />
              <Route path="/user/:directus_id" element={<QrRegistrationPage />} />
              <Route path="/" element={<RootRedirect />} />
            </Routes>
          </ModeProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
